var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmCyan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.68 22.68",
    style: {
      enableBackground: "new 0 0 22.68 22.68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#009FE3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.67,16.64c0,0.86,0.69,1.55,1.55,1.55s1.55-0.69,1.55-1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.48,15.68v-1.95h-1.3v-2.89c0-1.93-1.38-3.53-3.21-3.88c0-0.03,0.02-0.05,0.02-0.07 c0-0.42-0.34-0.76-0.76-0.76c-0.42,0-0.76,0.34-0.76,0.76c0,0.03,0.01,0.05,0.02,0.07c-1.83,0.35-3.21,1.95-3.21,3.88v2.89H6.21 v1.95H16.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.94,14.15c-0.12,0-0.24-0.04-0.33-0.13c-0.2-0.18-0.22-0.5-0.04-0.7c1.15-1.27,1.1-3.39-0.1-4.72 c-0.18-0.2-0.17-0.52,0.03-0.7c0.2-0.18,0.52-0.17,0.7,0.03c1.53,1.7,1.58,4.41,0.1,6.05C18.21,14.09,18.07,14.15,17.94,14.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.98,15.34c-0.12,0-0.24-0.04-0.34-0.13c-0.2-0.19-0.21-0.5-0.02-0.7c1.81-1.93,1.73-5.16-0.18-7.2 c-0.19-0.2-0.18-0.52,0.02-0.7c0.2-0.19,0.51-0.18,0.7,0.02c2.25,2.41,2.33,6.25,0.18,8.56C20.25,15.28,20.12,15.34,19.98,15.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.74,14.15c-0.14,0-0.27-0.05-0.37-0.16c-1.48-1.64-1.43-4.35,0.1-6.05c0.19-0.2,0.5-0.22,0.7-0.04 c0.2,0.18,0.22,0.5,0.04,0.7c-1.2,1.33-1.25,3.45-0.1,4.72c0.18,0.2,0.17,0.52-0.04,0.7C4.98,14.11,4.86,14.15,4.74,14.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.69,15.34c-0.13,0-0.27-0.05-0.36-0.16c-2.16-2.31-2.08-6.15,0.18-8.56c0.19-0.2,0.5-0.21,0.7-0.02 c0.2,0.19,0.21,0.5,0.02,0.7c-1.9,2.04-1.98,5.26-0.18,7.2c0.19,0.2,0.18,0.52-0.02,0.7C2.94,15.29,2.82,15.34,2.69,15.34"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmCyan);
export default __webpack_public_path__ + "static/media/alarm-cyan.47aad0bce88bd794338c7e765ed121bd.svg";
export { ForwardRef as ReactComponent };